import { useMutation } from "@shared/lib/hooks";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useDeleteUserFromOrganisation() {
  const { mutate, isLoading, isSuccess, error } = useMutation({
    mutationFn: (params: { userId: string; brandOrganisationId: string }) =>
      OrganisationService.deleteUserFromOrganisation(
        params.userId,
        params.brandOrganisationId
      ),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, _, { brandOrganisationId }) => {
      c.invalidateQueries({
        queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
      });
    },
  });

  return {
    deleteUserFromOrganisation: mutate,
    isUserDeleting: isLoading,
    isUserDeleted: isSuccess,
    deleteUserError: error,
  };
}
